import { SIZE_FULL } from '@/lib/gridElements/size';
import { MediasWidget } from '@/components/pages/analyze/widget/MediasWidget';

export const mostEngagingTweetsConfig = {
    title: 'chart.twitter.widget_most_engaging_tweets',
    id: 'widget_most_engaging_tweets',
    size: SIZE_FULL,
    sortFields: ['engagement_rate', 'created', 'likes', 'retweets', 'replies', 'impressions'],
    type: 'widget',
    element: MediasWidget
};
